import { ReactComponent as Trash } from '../../components/icons/trash.svg';
import { ReactComponent as SearchIcon } from '../../components/icons/search.svg';
import SortArrows from '../../components/icons/sort-arrows.jsx';
import CustomButton from '../../components/components/custom_button/customButton';
import CustomInput from '../../components/components/custom_input/customInput';
import {
  setSearch,
  setSearchValue,
  setCategory,
  setStatus,
  setSorting,
  setCheckedItems,
} from '../../store/documentsTabSlice';

// Actions for documents table
export const documentActions = {
  deleteSelected: async (selectedItems, dispatch, fetchDocuments, ...fetchParams) => {
    if (selectedItems.length === 0) {
      alert('Nie zaznaczono żadnych dokumentów.');
      return;
    }

    if (!window.confirm(`Czy na pewno chcesz usunąć ${selectedItems.length} dokument(ów)?`)) {
      return;
    }

    try {
      const ApiService = (await import('../../components/api_services/apiService.jsx')).default;
      await ApiService.bulkDeleteDocuments(selectedItems);
      dispatch(setCheckedItems([]));
      // Refresh the documents list
      fetchDocuments(...fetchParams);
      alert('Dokumenty zostały usunięte.');
    } catch (error) {
      console.error('Błąd podczas usuwania dokumentów:', error);
      alert('Wystąpił błąd podczas usuwania dokumentów.');
    }
  },
};

// Configuration for table headers
export const getHeaders = (
  sortBy,
  sortDirection,
  dispatch,
  setSorting,
  sortArrowColorActive,
  sortArrowColorInactive,
  rowsDocuments,
  checkedItems,
  documentsData,
  setCheckedItems
) => [
  <input
    key="select-all"
    type="checkbox"
    checked={
      documentsData &&
      documentsData.length > 0 &&
      documentsData.every((doc) =>
        checkedItems.some(
          (item) => item.category === doc.category && item.id === doc.id
        )
      )
    }
    onChange={(e) => {
      if (e.target.checked && documentsData) {
        // Select all visible documents
        dispatch(setCheckedItems([...documentsData]));
      } else {
        // Deselect all
        dispatch(setCheckedItems([]));
      }
    }}
  />,
  'ID',
  <div key="name-header" className="table-columns-headers">
    <div>Nazwa dokumentu</div>
    <SortArrows
      upColor={sortBy === 'name' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'name' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'name') {
          dispatch(setSorting({ sortBy: 'name', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'name', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="date-header" className="table-columns-headers">
    <div>Data utworzenia</div>
    <SortArrows
      upColor={sortBy === 'createdAt' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'createdAt' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'createdAt') {
          dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="user-header" className="table-columns-headers">
    <div>Użytkownik</div>
    <SortArrows
      upColor={sortBy === 'user' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'user' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'user') {
          dispatch(setSorting({ sortBy: 'user', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'user', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="status-header" className="table-columns-headers">
    <div>Status</div>
    <SortArrows
      upColor={sortBy === 'status' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'status' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'status') {
          dispatch(setSorting({ sortBy: 'status', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'status', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="category-header" className="table-columns-headers">
    <div>Kategoria</div>
    <SortArrows
      upColor={sortBy === 'category' && sortDirection === 'ASC' ? sortArrowColorActive : sortArrowColorInactive}
      downColor={sortBy === 'category' && sortDirection === 'DESC' ? sortArrowColorActive : sortArrowColorInactive}
      className="menu-icon"
      onClick={() => {
        if (sortBy !== 'category') {
          dispatch(setSorting({ sortBy: 'category', sortDirection: 'ASC' }));
        } else {
          if (sortDirection === 'ASC') {
            dispatch(setSorting({ sortBy: 'category', sortDirection: 'DESC' }));
          } else {
            dispatch(setSorting({ sortBy: 'createdAt', sortDirection: 'DESC' }));
          }
        }
      }}
    />
  </div>,
  <div key="actions-header">Akcje</div>,
];

// Column widths
export const headerWidths = [
  '42px', // checkbox
  '60px', // ID
  'minmax(200px, 3fr)', // Nazwa dokumentu
  'minmax(140px, 2fr)', // Data utworzenia
  'minmax(150px, 2fr)', // Użytkownik
  'minmax(100px, 1fr)', // Status
  'minmax(140px, 2fr)', // Kategoria
  'minmax(120px, 1fr)', // Akcje
];

// Configuration for tabs
export const tabsConfig = (activeDocumentsTab, dispatch, setActiveDocumentsTab) => [
  {
    name: 'Wygenerowane dokumenty',
    activeClass: activeDocumentsTab === 'Wygenerowane dokumenty' ? 'is-active' : '',
    onClick: () => dispatch(setActiveDocumentsTab('Wygenerowane dokumenty')),
    toggleActive: true,
  },
  {
    name: 'Szablony',
    activeClass: activeDocumentsTab === 'Szablony' ? 'is-active' : '',
    onClick: () => dispatch(setActiveDocumentsTab('Szablony')),
    toggleActive: true,
  },
];

// Configuration for buttons (empty for now)
export const buttonsConfig = [];

// Configuration for left side (delete button)
export const leftSideConfig = (checkedItems, dispatch, fetchDocuments, ...fetchParams) => [
  {
    component: CustomButton,
    props: {
      icon: Trash,
      name: 'Usuń zaznaczone',
      baseClass: 'custom-button-white',
      hoverClass: 'hover-effect',
      activeClass: '',
      borders: 'LRBT',
      onClick: () => documentActions.deleteSelected(checkedItems, dispatch, fetchDocuments, ...fetchParams),
      toggleActive: false,
    },
  },
];

// Configuration for right side (search)
export const rightSideConfig = (searchValue, dispatch) => [
  {
    component: CustomInput,
    props: {
      icon: SearchIcon,
      placeholder: 'Szukaj',
      hoverClass: 'hover-effect',
      borders: 'LRBT',
      bordersClassPrefix: 'border-black-',
      baseClass: 'custom-input',
      activeClass: '',
      value: searchValue,
      onChange: (e) => {
        e.preventDefault();
        let value = e.target.value;
        dispatch(setSearchValue(value));
        if (value.length >= 3) {
          dispatch(setSearch(value));
        } else {
          dispatch(setSearch(null));
        }
      },
    },
  },
];

// Filter configuration for category dropdown
export const categoryFilterOptions = [
  { value: null, label: 'wybierz' },
  { value: 'Rachunek', label: 'Rachunek' },
  { value: 'Time sheet', label: 'Time sheet' },
  { value: 'Time sheet weekly', label: 'Time sheet weekly' },
];

// Filter configuration for status dropdown
export const statusFilterOptions = [
  { value: null, label: 'wybierz' },
  { value: 'DRAFT', label: 'DRAFT' },
  { value: 'SUBMITTED', label: 'SUBMITTED' },
  { value: 'SENT', label: 'SENT' },
];

export const empty = [];

